import router from "@/router"
import axios from "axios"

export default ({
    namespaced: true,
    state: {
        positions: [],
        position: {},
        currentPage: 1,
        search: '',
        size: 10,
        order: 'created_at',
        add: {},
        totalPages: 0,
        selectedDelete: [],
        errorMessages: []
    },
    mutations: {
        setAllPositions(state, positions) {
            state.positions = positions
            state.totalPages = Math.ceil(positions.total / state.size) || 0
        },
        setPosition(state, position) {
            state.position = position
        }
    },
    actions: {
        async getAll({ commit, rootState, state }) {
            const filter = 'search=' + state.search + '&size=' + state.size + '&order=' + state.order + '&page=' + state.currentPage
            const url = rootState.baseUrl + '/api/v1/positions'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            // console.log(rootState.auth.accessToken)
            await axios.get(url + '?' + filter, { headers: header })
                .then(response => {
                    commit('setAllPositions', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async add({ state, rootState }, params) {
            const url = rootState.baseUrl + '/api/v1/positions'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.post(url, params, { headers: header })
                .then(response => {
                    this.dispatch('position/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    state.errorMessages.push(error.response.data)
                })
        },
        async delete({ state, rootState }, data) {
            const url = rootState.baseUrl + '/api/v1/positions/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }

            await Promise.all(
                data.map(id => axios.delete(url + id, { headers: header, data: {} }))
            );
            await this.dispatch('position/getAll')
        },
        async get({ commit, rootState, state }, data) {
            const url = rootState.baseUrl + '/api/v1/positions/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + data, { headers: header })
                .then(response => {
                    commit('setPosition', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async edit({ state, rootState }, params) {
            const id = state.position.id
            // console.log(params)
            const url = rootState.baseUrl + '/api/v1/positions/' + id
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.patch(url, params, { headers: header })
                .then(response => {
                    this.dispatch('position/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    state.errorMessages.push(error.response.data)
                })
        },
        async getAllPositions({ commit, rootState, state }) {
            const filter = 'size=all'
            const url = rootState.baseUrl + '/api/v1/positions'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + '?' + filter, { headers: header })
                .then(response => {
                    commit('setAllPositions', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
    }
})